/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1038
 */

module.exports = {
  content: "style_content__3UlyZ",
  alignRadio: "style_alignRadio__1L-oe"
}
